import { Application } from 'types/applications';
import { SelectCardWrapperPermissionsDetails } from 'types/commons';

import {
  ClientApplicationStages,
  SelectCardWrapperPermissions
} from 'constants/enums';

const stagePermissionsMap: Partial<
  Record<ClientApplicationStages, SelectCardWrapperPermissions[]>
> = {
  [ClientApplicationStages.AcceptedApplicationStageClient]: [
    SelectCardWrapperPermissions.ApplicationAccept,
    SelectCardWrapperPermissions.ApplicationReject,
    SelectCardWrapperPermissions.ApplicationScheduleInterview
  ],
  [ClientApplicationStages.ClientReviewApplicationStageClient]: [
    SelectCardWrapperPermissions.ApplicationAccept,
    SelectCardWrapperPermissions.ApplicationReject,
    SelectCardWrapperPermissions.ApplicationScheduleInterview,
    SelectCardWrapperPermissions.ApplicationSendOffer
  ],
  [ClientApplicationStages.CompletedApplicationStageClient]: [
    SelectCardWrapperPermissions.ApplicationAccept,
    SelectCardWrapperPermissions.ApplicationReject,
    SelectCardWrapperPermissions.ApplicationScheduleInterview
  ],
  [ClientApplicationStages.HiredApplicationStageClient]: [
    SelectCardWrapperPermissions.ApplicationAccept
  ],
  [ClientApplicationStages.NewApplicationStageClient]: [
    SelectCardWrapperPermissions.ApplicationAccept,
    SelectCardWrapperPermissions.ApplicationReject,
    SelectCardWrapperPermissions.ApplicationScheduleInterview,
    SelectCardWrapperPermissions.ApplicationSendOffer
  ],
  [ClientApplicationStages.DeclinedApplicationStageClient]: []
};

export const getApplicationActionPermissions = (
  application?: Application | null
): SelectCardWrapperPermissionsDetails[] => {
  const applicationStage = application?.clientStage;

  if (!applicationStage) {
    return [];
  }

  const permissionsMapItem = stagePermissionsMap[applicationStage];

  if (!permissionsMapItem) {
    return [];
  }

  const permissionsDetails = permissionsMapItem.map((permission) => {
    let isAllowed = true;

    switch (permission) {
      case SelectCardWrapperPermissions.ApplicationSendOffer: {
        const isOfferLetterSent = Boolean(application.offerId);
        isAllowed = !isOfferLetterSent;
        break;
      }

      case SelectCardWrapperPermissions.ApplicationScheduleInterview: {
        const isInterviewRequestSent = Boolean(
          application.interviewRequestSent
        );
        isAllowed = !isInterviewRequestSent;
        break;
      }
    }

    return {
      permission,
      isAllowed
    };
  });

  return permissionsDetails;
};
